import {
  CsvExportDefinition,
  formatMillisecondsDate
} from "../../common/csvExport";

interface ProjectExportRecord {
  id: string | number;
  title?: string;
  totalProjectPatientCount?: number;
  startedAt?: number;
  updatedAt?: number;
  lastOutreachAt?: number;
  type?: string;
  createdBy?: string;
  description?: string;
}

const dateOptions: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "short",
  day: "numeric"
};

export const projectExportDefinition: CsvExportDefinition<ProjectExportRecord> =
  {
    resource: "Project",
    filenameStem: "projects",
    id: { header: "projectID", source: "id" },
    columns: [
      {
        key: "title",
        label: "Project Name",
        source: "title",
        getValue: (r) => r.title
      },
      {
        key: "patients",
        label: "Patients",
        source: "totalProjectPatientCount",
        getValue: (r) => r.totalProjectPatientCount
      },
      {
        key: "startedAt",
        label: "Start date",
        source: "startedAt",
        getValue: (r) => formatMillisecondsDate(r.startedAt, dateOptions)
      },
      {
        key: "updatedAt",
        label: "Last update",
        source: "updatedAt",
        getValue: (r) => formatMillisecondsDate(r.updatedAt, dateOptions)
      },
      {
        key: "lastOutreachAt",
        label: "Last outreach",
        source: "lastOutreachAt",
        getValue: (r) =>
          formatMillisecondsDate(r.lastOutreachAt, dateOptions, "—")
      },
      { key: "type", label: "Type", source: "type", getValue: (r) => r.type },
      {
        key: "createdBy",
        label: "Creator",
        source: "createdBy",
        getValue: (r) => r.createdBy
      },
      {
        key: "description",
        label: "Description",
        source: "description",
        getValue: (r) => r.description
      }
    ]
  };
